import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { ComboBox } from '../../../../../../../shared/components/form-components/autocomplete-components/ComboBox/ComboBox';
import { getTimezoneOptions } from '../../../../../../../shared/utils/timezoneUtils/getTimezoneOptions';

type Props = {
  onNext: () => void;
};

const TimezoneStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();

  const timezoneOptions = useMemo(() => getTimezoneOptions(), []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger('importantDates.timeZone');

    if (isValid) {
      onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate>
      <ComboBox
        control={control}
        name="importantDates.timeZone"
        label="Timezone"
        size="small"
        variant="standard"
        options={timezoneOptions}
        rules={{ required: 'Timezone is required' }}
      />
    </form>
  );
};

export { TimezoneStep };
